<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./ratings.scss" lang="scss"></style>

<script>
  import Qs from 'qs'
  import SearchFilter from './SearchFilter'
  import { mapActions, mapState } from 'vuex'
  import AppPagination from '@/components/ui/AppPagination'
  import { omit, clone, isEmpty, pickBy, identify } from 'lodash'
  import FiltersOverlay from '@/components/overlays/FiltersOverlay'

  export default {
    name: 'HotelOverviewPage',
    components: {
      SearchFilter,
      AppPagination,
      FiltersOverlay,
      NewsTeaserHorizontal: () => import('@/components/modules/NewsTeaserHorizontal'),
    },
    metaInfo() {
      return {
        title: this.$t('locations.page_title'),
      }
    },
    data() {
      return {
        page: 1,
        showFilters: false,
      }
    },
    computed: {
      ...mapState('ratingsLocation', [
        'filters',
        'ratings',
        'options',
        'pagination',
        'filterActive',
        'filterOptions',
      ]),
      getExportURL() {
        const filtered = pickBy(this.filters, identify)
        const filterObj = Qs.stringify({ ...filtered, locale: this.$i18n.formatedLocale }, { arrayFormat: 'brackets' })
        return `${process.env.VUE_APP_API_URL}ratings/ratings_export?${filterObj}`
      },
      getFiltersCount() {
        const rest = omit(this.filters, ['date'])

        return Object.values(rest).filter(v => v !== null).length
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1

        if (this.filterActive) {
          this.filterRatings({ page: this.page })
        } else {
          this.getRatings(this.page)
        }
      },
    },
    created() {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
        this.getRatings(this.$route.query.page)
      } else {
        this.getRatings(this.page)
      }
      if (isEmpty(this.filterOptions)) {
        this.getRatingsFilters()
      }
    },
    mounted() {
      this.moveButton()
    },
    beforeDestroy() {
      this.removeButton()
    },
    destroyed() {
      this.clearRatings()
    },
    methods: {
      ...mapActions('ratingsLocation', [
        'getRatings',
        'resetFilter',
        'clearRatings',
        'updateFilters',
        'filterRatings',
        'setFilterActive',
        'getRatingsFilters',
      ]),
      onFilter(page = 1) {
        this.setFilterActive()
        if (parseInt(this.$route.query.page) !== parseInt(page)) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          this.filterRatings({ page })
        }
      },
      updateRatings(page = 1) {
        this.getRatings(page)
      },
      onFiltersApplied(filters) {
        this.showFilters = false
        this.updateFilters(clone(filters))
        this.onFilter()
      },
      onFiltersReset() {
        this.resetFilter()
        this.updateRatings()
      },
      moveButton() {
        const moveButton = setInterval(() => {
          const filterButton = document.querySelector('.filter-fab')
          if (filterButton) {
            const target = document.querySelector('.v-main')
            clearInterval(moveButton)
            if (target) {
              target.append(filterButton)
              filterButton.classList.remove('invisible')
            }
          }
        }, 200)
      },
      removeButton() {
        const filterButton = document.querySelector('.v-main > .filter-fab')

        if (filterButton) {
          filterButton.remove()
        }
      },
    },
  }
</script>
